module.exports = __webpack_public_path__ + "img/qr-code.a32de245.svg";